export default __webpack_public_path__ + "static/media/bancard.aec7342a.svg";